<template>
  <main class="app-content" v-if="agency">
    <aside class="fixed-sidebar">
      <side-bar :agency="agency"></side-bar>
    </aside>
    <div class="project-layout app-content">
      <template>
        <header class="project-header">
          <h1>{{ agency.displayName }}</h1>
        </header>
      </template>
      <div class="container-fluid">
        <router-link
          :to="'/offices?selectedClient=' + queryParams"
          style="margin-top:15px"
          v-if="user && user.role !== 'ROLE_AGENT_USER'"
        >
          <button type="button" v-if="true" class="btn btn-quaternary">
            BACK TO {{ agency.client.title }} OFFICES
          </button>
        </router-link>
        <div class="order-media">
          <vue-form
            :state="formState"
            name="officeCampaignForm"
            @submit.prevent=""
            ref="form"
          >
            <div class="row">
              <div class="col-6 pad-for-submission">
                <div class="form-group">
                  <div>
                    {{ agency.displayName }}
                  </div>
                  <label>Office Name</label>
                </div>

                <div class="form-group" v-if="canAccessAudienceFeatures">
                  <select class="custom-select" v-model="selectedAudience">
                    <option :value="null">Select an audience</option>
                    <template v-for="audience in audiences">
                      <option :value="audience" :key="audience.id">
                        {{ audience.scopeDisplay }} Audience -
                        {{ audience.name }}
                      </option>
                    </template>
                  </select>
                  <label class="label-with-button"
                    >Select Audience (optional)</label
                  >
                </div>

                <validate class="form-group">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      name="destinationUrl"
                      v-model="officeCampaign.destinationUrl"
                      placeholder=""
                      required
                      @keyup="validateDestinationUrl"
                    />
                    <field-messages
                      name="destinationUrl"
                      show="$dirty && $invalid"
                    >
                      <div class="error" slot="required">
                        Destination URL is required
                      </div>
                    </field-messages>
                  </div>
                  <div class="error" v-if="destinationUrlError">
                    Destination URL must be a valid https url
                  </div>
                  <label class="small">Ad click destination</label>
                  <label>Destination URL *</label>
                </validate>
                <validate class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    name="postcode"
                    v-model="officeCampaign.postcode"
                    required
                    max-list-len="4"
                  />
                  <field-messages name="postcode" show="$dirty && $invalid">
                    <div class="error" slot="required">
                      Postcodes is required
                    </div>
                    <div class="error" slot="max-list-len">
                      Maximum 4 Postcodes
                    </div>
                  </field-messages>
                  <label class="small"
                    >To Geotarget your campaign (SEPARATE BY COMMAS I.E 3000,
                    3001)</label
                  >
                  <label>Office Target Postcodes (1-4) *</label>
                </validate>

                <div class="form-group">
                  <select
                    class="custom-select"
                    v-model="selectedPackage"
                    @change="validateSignifiCreatives"
                  >
                    <option value="null">Select Campaign Package</option>
                    <template v-for="product in packages">
                      <option
                        :value="product"
                        :key="product.id"
                        v-if="product.type == 'office'"
                        >{{ product.title }}</option
                      >
                    </template>
                  </select>
                  <div class="error" v-if="selectedPackageError">
                    Campaign Package is required
                  </div>
                  <label class="small">Select the required package.</label>
                  <label class="label-with-button">Campaign Package *</label>
                </div>
                <template>
                  <div class="form-group">
                    <div class="date-time-picker-container">
                      <DateTimePicker
                        color="#13a3eb"
                        class="mr-sm-2"
                        noLabel
                        formatted="DD MMM YYYY"
                        format="YYYY-MM-DD"
                        autoClose
                        input-size="sm"
                        :min-date="minDate"
                        v-model="officeCampaign.startDate"
                        noButton
                        noClearButton
                        :no-value-to-custom-elem="false"
                        only-date
                        label="Select start date"
                      >
                      </DateTimePicker>
                      <br />
                    </div>
                    <div class="error" v-if="startDateError">
                      Start date is required
                    </div>
                    <label class="small"
                      >Select the date you would like the campaign to
                      start</label
                    >
                    <label>Campaign start Date *</label>
                  </div>
                </template>

                <div class="form-group">
                  <select
                    class="custom-select"
                    v-model="officeCampaign.subType"
                    @change="validateSubType"
                  >
                    <option value="">Select Campaign Type</option>
                    <option value="OfficeBranding">Branding Campaign</option>
                    <option value="OfficeRecruitment"
                      >Recruitment Campaign</option
                    >
                    <option value="PropertyManagement"
                      >Property Management</option
                    >
                  </select>
                  <div class="error" v-if="subTypeError">
                    Campaign Type is required
                  </div>
                  <label class="small"
                    >Select the required campaign type.</label
                  >
                  <label class="label-with-button">Campaign Type *</label>
                </div>
              </div>
              <div class="col-6 pad-for-submission">
                <template v-if="selectedPackage">
                  <validate
                    class="form-group"
                    v-if="!selectedPackage.videoRequired"
                  >
                    <select
                      class="custom-select"
                      required
                      name="label"
                      v-model="officeCampaign.label"
                      @change="validateLabel"
                    >
                      <option value="">Select Label</option>
                      <option value="Get in touch">Get in touch</option>
                      <option value="Find out more">Find out more</option>
                      <option value="Request an appraisal"
                        >Request an appraisal</option
                      >
                      <option value="Contact us">Contact us</option>
                      <option value="Learn more">Learn more</option>
                    </select>
                    <div class="error" v-if="labelError">
                      CTA Button Text is required
                    </div>
                    <label class="small"
                      >Select the text within the CTA Button</label
                    >
                    <label class="label-with-button">CTA Button Text *</label>
                  </validate>
                  <validate
                    class="form-group"
                    v-if="!selectedPackage.videoRequired"
                  >
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        name="headline"
                        v-model="officeCampaign.headline"
                        placeholder=""
                        required
                        @change="validateSignifiCreatives"
                        maxlength="50"
                      />
                      <field-messages name="headline" show="$dirty && $invalid">
                        <div class="error" slot="required">
                          Headline is required
                        </div>
                      </field-messages>
                    </div>
                    <label class="small"
                      >50 characters (including spaces) MAX</label
                    >
                    <label>Headline (for display ads) *</label>
                  </validate>
                  <validate class="form-group">
                    <div>
                      <textarea
                        class="form-control"
                        name="shortDescription"
                        v-model="officeCampaign.shortDescription"
                        placeholder=""
                        maxlength="150"
                        required
                        @change="validateSignifiCreatives"
                      ></textarea>
                      <field-messages
                        name="shortDescription"
                        show="$dirty && $invalid"
                      >
                        <div class="error" slot="required">
                          Ad Copy is required
                        </div>
                      </field-messages>
                    </div>
                    <label class="small"
                      >150 characters (including spaces) MAX</label
                    >
                    <label>Ad Copy (For Social Ads) *</label>
                  </validate>

                  <div class="form-group" v-if="selectedPackage.videoRequired">
                    <div class="row" style="margin-top: 10px">
                      <div class="col-4">
                        <video-upload
                          :video="video"
                          :displayLabel="false"
                          :handleFileChange="handleVideoFileChange"
                          ref="videoRef"
                        />
                      </div>
                    </div>
                    <label
                      >Video<span style="font-size: 12px;"
                        ><br />MP4 only max 1GB</span
                      >
                      <div
                        v-if="videoSizeError"
                        style="color: red;font-size: 12px; margin-top: 8px;"
                      >
                        {{ VIDEO_ERROR_MESSAGES.MAX_SIZE }}
                      </div></label
                    >
                  </div>
                  <div class="form-group" v-if="!selectedPackage.videoRequired">
                    <div class="col-4" style="padding:0; margin-top:10px">
                      <logo-upload
                        :logo="officeCampaign.mainImage"
                        name="mainImage"
                        :displayLabel="false"
                        ref="mainImageRef"
                        v-if="renderComponent"
                        v-on:logoupload="mainImageUpdated = true"
                        :showCheckerboard="false"
                      />
                    </div>
                    <div class="error" v-if="mainImageSizeError">
                      Key Image must be 1MB Max Size
                    </div>
                    <div class="error" v-if="mainImageError">
                      Key Image is required
                    </div>
                    <label class="small"
                      >1080 x 1080 square image designed to recommended specs
                      only.</label
                    >
                    <label>Key Image *</label>
                  </div>

                  <div>
                    <div>
                      <label class="bold">Additional Report Recipients</label>
                      <br />
                      <label class="small"
                        >ADD ADDITIONAL RECIPIENTS FOR THE CAMPAIGN
                        REPORTS</label
                      >
                      <br />
                      <div
                        class="mb-1"
                        v-for="(recipient, index) in recipientLists"
                        :key="'recipient' + index"
                      >
                        <validate>
                          <input
                            class="form-control inline no-m-l"
                            type="email"
                            v-model="recipientLists[index]"
                            :name="'recipient' + index"
                            required
                          />
                          <button
                            type="button"
                            class="btn-remove"
                            @click="removeRecipient(index)"
                          >
                            &times;
                          </button>
                          <field-messages
                            :name="'recipient' + index"
                            show="$dirty && $invalid"
                          >
                            <div class="error" slot="required">
                              Email is required otherwise remove this field
                            </div>
                            <div class="error" slot="email">
                              Email is not valid
                            </div>
                          </field-messages>
                        </validate>
                      </div>
                      <div class="space-between">
                        <button
                          class="btn-link mt-1 mb-2"
                          @click="addRecipient"
                        >
                          Add recipient
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <div class="submission-details">
              <div class="form-group">
                <div class="space-between">
                  <div></div>
                  <div>
                    <div class="text-right">
                      Package Fee:
                      <span class="bold" v-if="selectedPackage">{{
                        selectedPackage.packagePrice | formatCurrency
                      }}</span>
                    </div>
                    <div class="text-right bold" v-if="agency.includeGst">
                      GST 10% Tax:
                      <span v-if="selectedPackage">{{
                        (selectedPackage.packagePrice * 0.1) | formatCurrency
                      }}</span>
                    </div>
                    <div class="text-right bold" v-if="selectedPackage">
                      Total <span v-if="agency.includeGst">(incl. GST)</span
                      ><span v-else>(excl. GST)</span>:
                      <span v-if="selectedPackage">{{
                        formatTotalPrice(selectedPackage) | formatCurrency
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="submission-btn-container">
                  <div class="c__btn--container btn-pad-right">
                    <button
                      class="btn btn-quaternary"
                      @click="openCreativeModal"
                      v-if="selectedPackage && !selectedPackage.videoRequired"
                      :disabled="!liveCreatives"
                      :class="{disabled: !liveCreatives}"
                    >
                      Preview Ad Creative
                    </button>
                  </div>
                  <div>
                    <div class="c__btn--container">
                      <button
                        class="btn btn-primary"
                        @click="openModal"
                        type="submit"
                        :disabled="disableSubmit"
                      >
                        Confirm and pay
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-form>
        </div>
      </div>
      <result-message :errors="errors"></result-message>
      <transition name="modal">
        <order-media-modal
          :campaign="officeCampaign"
          :campaignId="officeCampaignId"
          :agency="agency"
          :_package="selectedPackage"
          :total="selectedPackage.packagePrice * 1.1"
          :start-date="officeCampaign.startDate"
          v-if="showModal"
          @closeModal="closeModal"
          @closeModalAndCleanCampaign="closeModalAndCleanCampaign"
        ></order-media-modal>
      </transition>

      <transition name="modal">
        <creative-modal
          v-if="showCreativeModal"
          :agencyId="this.selectedAgency.id"
          :campaign="this.officeCampaign"
          :closeModal="closeCreativeModal"
          :logoUrl="officeLogoPreviewUrl"
        ></creative-modal>
      </transition>

      <app-modal-progress-bar
        :state="videoUploadProgress.state"
        :progress="videoUploadProgress.progress"
        :label="videoUploadProgress.label"
        :onCancel="onCancelVideoUpload"
        v-if="videoUploadProgress.visible"
      ></app-modal-progress-bar>
    </div>
  </main>
</template>

<script>
import axios from 'axios';
import SideBar from '../SideBar';

import Multiselect from 'vue-multiselect';

import DateTimePicker from 'vue-ctk-date-time-picker';
import ResultMessage from '../../../helpers/ResultMessage';
import LogoUpload from '../../../helpers/LogoUpload';
import VideoUpload from '../../../helpers/VideoUpload';
import MultiFileUpload from '../../../helpers/MultiFileUpload';

import AgencyService from '../../../services/agencies';
import FileService from '../../../services/files';

import OrderMediaModal from '../OrderMediaModal';
import CreativeModal from '../CreativeModal';
import CampaignServices from '../../../services/campaigns';
import Navigation from '../../../configs/Perimeters/navigation';
import AudienceServiceV2 from '../../../services/V2/AudienceServiceV2';
import {VIDEO_ERROR_MESSAGES, VIDEO_LIMITS} from '../../../configs/videoLimits';
import AppModalProgressBar from '../../AppComponents/Loaders/AppModalProgressBar.vue';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';

export default {
  components: {
    SideBar,
    ResultMessage,
    OrderMediaModal,
    DateTimePicker,
    LogoUpload,
    VideoUpload,
    CreativeModal,
    MultiFileUpload,
    Multiselect,
    AppModalProgressBar,
  },
  data() {
    return {
      user: null,
      agency: null,
      minDate: null,
      officeCampaignId: null,
      showModal: false,
      agencyPackages: null,
      clientPackages: null,
      packages: null,
      users: null,
      officeCampaign: {
        type: 'office',
        name: '',
        email: '',
        phone: '',
        destinationUrl: '',
        headline: '',
        label: '',
        subType: '',
        additionalRecipients: [],
        videoUrl: '',
      },
      destinationUrlError: false,
      postcodeError: false,
      propertyImageError: false,
      propertyImageSizeError: false,
      videoError: false,
      videoUrlError: false,
      mainImageError: false,
      mainImageSizeError: false,
      selectedPackage: null,
      selectedPackageError: false,
      startDateError: false,
      labelError: false,
      subTypeError: false,
      selectedAgency: null,
      errors: {
        type: Object | Error,
        $clean: true,
      },
      formState: {},
      renderComponent: true,
      mainImageUpdated: false,
      mainImageTempLocation: '',
      liveCreatives: false,
      showCreativeModal: false,
      destinationUrlChanged: false,
      recipientLists: [],
      disableSubmit: false,
      audiences: [],
      selectedAudience: null,
      video: null,
      videoSizeError: false,
      videoFileTypeError: false,
      VIDEO_ERROR_MESSAGES: VIDEO_ERROR_MESSAGES,
      VIDEO_LIMITS: VIDEO_LIMITS,
      videoUploadProgress: {
        progress: 0,
        visible: false,
        label: 'Uploading your video, please wait...',
        state: 'loading',
      },
      videoUploadController: null,
    };
  },
  methods: {
    formatTotalPrice(selectedPackage) {
      const price = this.agency.includeGst
        ? selectedPackage.packagePrice * 1.1
        : selectedPackage.packagePrice;
      return price;
    },
    updateMinDate() {
      let today = new Date();
      this.minDate = new Date();
      this.minDate.setDate(today.getDate() + 1);
      let dd = String(this.minDate.getDate()).padStart(2, '0');
      let mm = String(this.minDate.getMonth() + 1).padStart(2, '0');
      let yyyy = this.minDate.getFullYear();
      this.minDate = yyyy + '-' + mm + '-' + dd;
      this.validateSignifiCreatives();
    },
    validateDestinationUrl() {
      if (
        typeof this.officeCampaign.destinationUrl != 'undefined' &&
        this.officeCampaign.destinationUrl !== '' &&
        this.officeCampaign.destinationUrl.substring(0, 5) !== 'https'
      ) {
        this.destinationUrlError = true;
      } else {
        const blockedDomains = [
          'realestate.com.au',
          'domain.com.au',
          'homely.com.au',
          'ratemyagent.com.au',
          'propertymate.com.au',
        ];

        const urlLower = this.officeCampaign.destinationUrl.toLowerCase();
        for (const domain of blockedDomains) {
          if (
            urlLower.includes(`.${domain}`) ||
            urlLower.includes(`https://${domain}`) ||
            urlLower.includes(`https://www.${domain}`)
          ) {
            this.destinationUrlError = true;
            return false;
          }
        }
        this.destinationUrlError = false;
      }
    },
    validatePostcode() {
      if (
        typeof this.officeCampaign.postcode != 'undefined' &&
        this.officeCampaign.postcode !== ''
      ) {
        let postcodeArray = this.officeCampaign.postcode.split(',');
        if (postcodeArray.length > 4) {
          this.postcodeError = true;
        }
      } else {
        this.postcodeError = false;
      }
    },
    validateMainImage() {
      if (this.selectedPackage && this.selectedPackage.videoRequired) {
        this.mainImageError = false;
      } else {
        if (
          this.officeCampaign.mainImage &&
          (!this.$refs.mainImageRef || !this.$refs.mainImageRef.newLogo)
        ) {
          // Image provided against main image selection
          this.mainImageError = false;
        } else if (
          !this.$refs.mainImageRef ||
          typeof this.$refs.mainImageRef.uploadFile.size === 'undefined'
        ) {
          // No image provided
          this.mainImageError = true;
        } else {
          // Image uploaded against main image field
          this.mainImageError = false;
          if (this.$refs.mainImageRef.uploadFile.size > 1024000) {
            this.mainImageSizeError = true;
          } else {
            this.mainImageSizeError = false;
          }
        }
      }
    },
    isValidUrl(string) {
      return string.toLowerCase().startsWith('https://');
    },
    validatePackage() {
      if (!this.selectedPackage) {
        this.selectedPackageError = true;
      } else {
        this.selectedPackageError = false;
      }
    },
    validateLabel() {
      if (
        !this.selectedPackage.videoRequired &&
        (!this.officeCampaign.label || this.officeCampaign.label == '')
      ) {
        this.labelError = true;
      } else {
        this.labelError = false;
      }
    },
    validateSubType() {
      if (!this.officeCampaign.subType || this.officeCampaign.subType == '') {
        this.subTypeError = true;
      } else {
        this.subTypeError = false;
      }
    },
    validateVideoFile() {
      let hasError = false;
      // Reset all video errors
      this.videoSizeError = false;
      this.videoFileTypeError = false;

      // Check if video is required
      if (!this.selectedPackage || !this.selectedPackage.videoRequired) {
        return true;
      }

      // Check if it's a File instance
      if (this.video instanceof File) {
        // Check file size
        if (this.video.size > VIDEO_LIMITS.MAX_SIZE) {
          hasError = true;
          this.videoSizeError = true;
        }

        // Check file type
        const isValidType =
          this.video.type === 'video/mp4' &&
          this.video.name.toLowerCase().endsWith('.mp4');

        if (!isValidType) {
          hasError = true;
          this.videoFileTypeError = true;
        }

        return !hasError;
      }

      return true;
    },
    validateStartDate() {
      if (!this.officeCampaign.startDate) {
        this.startDateError = true;
      } else {
        this.startDateError = false;
      }
    },
    validate() {
      this.validateDestinationUrl();
      this.validatePostcode();
      this.validateMainImage();
      this.validatePackage();
      this.validateStartDate();
      this.validateLabel();
      this.validateSubType();

      if (
        this.destinationUrlError ||
        this.postcodeError ||
        this.mainImageError ||
        this.mainImageSizeError ||
        this.selectedPackageError ||
        this.startDateError ||
        this.labelError ||
        this.subTypeError
      ) {
        return false;
      }

      return true;
    },
    async openModal() {
      if (!this.validate() || this.formState.$invalid) {
        // Mark any fields as dirty that might not have been touched so that errors appear
        this.formState.$error
          ? Object.entries(this.formState.$error).forEach((entry) => {
              entry[1].$dirty = true;
            })
          : null;
        return;
      }

      event.preventDefault();
      this.disableSubmit = true;

      if (this.selectedPackage.videoRequired) {
        this.officeCampaign.headline = this.agency.displayName;
      }

      this.officeCampaign.package = this.selectedPackage.id;
      this.officeCampaign.agency = this.selectedAgency.id;
      this.officeCampaign.audience = this.selectedAudience
        ? this.selectedAudience.id
        : null;
      this.officeCampaign.additionalRecipients = this.recipientLists.toString();
      if (this.selectedAgency.officeCampaignPaymentOption) {
        this.officeCampaign.paymentOption = this.selectedAgency.officeCampaignPaymentOption;
      } else {
        this.officeCampaign.paymentOption = this.selectedAgency.client.officeCampaignPaymentOption;
      }

      if (
        this.officeCampaign.mainImage &&
        typeof this.officeCampaign.mainImage !== 'undefined' &&
        (!this.$refs.mainImageRef || !this.$refs.mainImageRef.newLogo)
      ) {
        // Send existing mainImage ID
        this.officeCampaign.mainImage = this.officeCampaign.mainImage.id;
      } else if (
        this.$refs.mainImageRef &&
        typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
      ) {
        let formData = new FormData();
        formData.append('image', this.$refs.mainImageRef.uploadFile);
        formData.append('subType', 'office-image');
        await FileService.uploadFile(formData)
          .then((image) => {
            this.officeCampaign.mainImage = image.id;
          })
          .catch((errors) => {
            this.errors = errors;
            return;
          });
      }
      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }

      await CampaignServices.createCampaign(this.officeCampaign)
        .then((officeCampaign) => {
          if (officeCampaign && officeCampaign.id) {
            this.officeCampaignId = officeCampaign.id;
            this.officeCampaign.mainImage = officeCampaign.mainImage;
          }
        })
        .catch((errors) => {
          this.errors = errors;
          return;
        });
      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }

      await this.uploadVideo(this.officeCampaignId);
      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }
      this.showModal = true;
    },
    async uploadVideo(campaignId) {
      // Handle URL-based video upload
      if (this.officeCampaign.videoUrl) {
        await CampaignServices.uploadVideoViaUrl(
          campaignId,
          this.officeCampaign.videoUrl
        ).catch((errors) => {
          this.errors = errors;
          return;
        });
      }
      this.validateSignifiCreatives();
    },
    closeModal() {
      this.showModal = false;
      this.disableSubmit = false;
    },
    closeModalAndCleanCampaign() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
        this.officeCampaign = {
          type: 'office',
          name: this.agency.displayName,
          phone: this.agency.phone,
          postcode: this.agency.postcode,
          email: this.agency.email,
          destinationUrl: this.agency.destinationUrl,
        };
        this.selectedPackage = null;
        this.$refs.form.reset();
      });
      this.showModal = false;
      this.disableSubmit = false;
    },
    getAgency() {
      AgencyService.getAgency(
        this.$route.params.agency,
        'automateReport,client,permissions,ordersReport'
      ).then((agency) => {
        this.agency = agency;
        this.selectedAgency = agency;
        this.agencyPackages = agency.packages ? agency.packages.data : [];
        this.clientPackages = agency.client.packages
          ? agency.client.packages.data
          : [];
        this.packages = [...this.agencyPackages, ...this.clientPackages];
        this.packages = Array.from(new Set(this.packages.map((a) => a.id))).map(
          (id) => {
            return this.packages.find((a) => a.id === id);
          }
        );
        this.packages = this.packages.filter(
          (pack) => pack.status == 'published'
        );
        this.packages.sort((a, b) =>
          a.sortOrder > b.sortOrder ? 1 : b.sortOrder > a.sortOrder ? -1 : 0
        );
        this.officeCampaign.name = this.agency.displayName;
        this.officeCampaign.postcode = this.agency.postcode;
        this.officeCampaign.phone = this.agency.phone;
        this.officeCampaign.email = this.agency.email;
        this.officeCampaign.destinationUrl = this.agency.destinationUrl;
        this.validateSignifiCreatives();

        AudienceServiceV2.getScopedAudiences({agencyId: agency.id}).then(
          (response) => {
            if (response.data.data) {
              this.audiences = response.data.data;
            }
          }
        );
      });
    },
    validateSignifiCreatives() {
      if (
        typeof this.officeCampaign.name == 'undefined' ||
        this.officeCampaign.name == ''
      ) {
        this.liveCreatives = false;
        return;
      }
      if (!this.selectedPackage || !this.selectedPackage.videoRequired) {
        if (
          typeof this.officeCampaign.headline == 'undefined' ||
          this.officeCampaign.headline == ''
        ) {
          this.liveCreatives = false;
          return;
        }
        if (
          typeof this.officeCampaign.mainImage == 'undefined' ||
          this.officeCampaign.mainImage == ''
        ) {
          if (
            typeof this.mainImageTempLocation == 'undefined' ||
            this.mainImageTempLocation == ''
          ) {
            this.liveCreatives = false;
            return;
          }
        }
      }
      if (
        typeof this.mainImageTempLocation != 'undefined' &&
        this.mainImageTempLocation != ''
      ) {
        this.officeCampaign.mainImageTempLocation = this.mainImageTempLocation;
      }
      this.liveCreatives = true;
    },
    uploadTemporaryFile() {
      let formData = null;
      formData = new FormData();
      let imageType = null;
      if (this.mainImageUpdated) {
        if (
          this.$refs.mainImageRef &&
          typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
        ) {
          formData.append('image', this.$refs.mainImageRef.uploadFile);
        }
        this.mainImageUpdated = false;
        imageType = 'office';
      }
      if (imageType) {
        FileService.uploadTempFile(formData)
          .then((response) => {
            this.mainImageTempLocation = response;
            this.validateSignifiCreatives();
            this.validateMainImage();
          })
          .catch((errors) => {});
      }
    },
    openCreativeModal() {
      if (this.liveCreatives) {
        this.showCreativeModal = true;
      }
    },
    closeCreativeModal() {
      this.showCreativeModal = false;
    },
    addRecipient() {
      this.recipientLists.push('');
    },
    removeRecipient(index) {
      this.recipientLists.splice(index, 1);
    },
    onCancelVideoUpload() {
      // Cancel the ongoing API request
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }
      this.videoUploadProgress.visible = false;
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.label = 'Uploading your video, please wait...';
      this.video = null;
      this.officeCampaign.videoId = null;
      if (this.$refs.videoRef) {
        this.$refs.videoRef.clearVideo();
      }
    },
    async handleVideoFileChange(file) {
      // Clear any existing controller first
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }

      this.videoUploadController = new AbortController();

      this.video = file;
      const isValid = this.validateVideoFile();

      if (!isValid) {
        this.videoUploadController = null;
        return;
      }

      this.videoError = false;
      this.videoSizeError = false;
      this.videoFileTypeError = false;
      this.videoUploadProgress.visible = true;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.label = 'Uploading your video, please wait...';

      try {
        const presignedData = await CampaignServiceV2.getUploadPresignedUrl(
          file.name
        );

        const onProgress = (progress) => {
          if (progress < 95) {
            this.videoUploadProgress.progress = progress;
          }
        };

        await CampaignServiceV2.uploadBinaryToPresignedUrl(
          presignedData.data.url,
          file,
          onProgress,
          this.videoUploadController
        );

        const registeredVideo = await CampaignServiceV2.registerVideo({
          filename: presignedData.data.filename,
        });

        this.officeCampaign.videoId = registeredVideo.data.id;
        this.videoError = false;

        this.videoUploadProgress.progress = 100;
        this.videoUploadProgress.state = 'loaded';
        this.videoUploadProgress.label = 'Video upload successful.';
      } catch (error) {
        // Handle abort specifically - for axios 0.18.0 cancellation
        if (
          error.name === 'AbortError' ||
          error.message.includes('aborted') ||
          error.code === 'ERR_CANCELED' ||
          axios.isCancel(error) ||
          error.message.includes('cancelled') ||
          error.message === 'Upload cancelled by user'
        ) {
          this.videoUploadProgress.state = 'cancelled';
          this.videoUploadProgress.label = 'Video upload cancelled.';
          // Don't clear video on cancel, just hide progress
          setTimeout(() => {
            this.videoUploadProgress.visible = false;
          }, 1000);
          return;
        }

        // Handle other errors
        this.video = null;
        this.officeCampaign.videoId = null;
        if (this.$refs.videoRef) {
          this.$refs.videoRef.clearVideo();
        }
        this.videoUploadProgress.state = 'error';
        this.videoUploadProgress.label =
          'Video upload failed. Please try again.';
        setTimeout(() => {
          if (this.$refs.videoRef) {
            this.$refs.videoRef.clearVideo();
          }
        }, 2000);
      } finally {
        // Clean up the controller
        if (this.videoUploadController) {
          this.videoUploadController = null;
        }

        // Hide progress bar after delay (unless it was cancelled, which handles its own timeout)
        setTimeout(() => {
          if (this.videoUploadProgress.state !== 'cancelled') {
            this.videoUploadProgress.visible = false;
          }
        }, 2000);
      }
    },
  },
  computed: {
    canAccessAudienceFeatures() {
      return (
        Navigation.isAllowed('accessAudienceFeatures') ||
        Navigation.isAdmin() ||
        Navigation.isSuperAdmin()
      );
    },
    queryParams() {
      return JSON.stringify({
        id: this.agency.client.id,
        title: this.agency.client.title,
      });
    },
    officeLogoPreviewUrl() {
      if (
        !this.agency ||
        !this.agency.imageLogo ||
        !this.agency.imageLogo.location
      ) {
        return null;
      }

      return process.env.VUE_APP_CDN_URL + this.agency.imageLogo.location;
    },
  },
  mounted() {
    this.updateMinDate();
    this.getAgency();
    this.user = this.$store.getters.getUser;
  },
  watch: {
    mainImageUpdated: {
      handler: function(val) {
        if (
          val &&
          this.$refs.mainImageRef &&
          typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
        ) {
          this.uploadTemporaryFile();
        }
      },
    },
  },
};
</script>

<style lang="css" scoped>
.order-media {
    position: relative;
}

.submission-details {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-right: 30px;
}

.submission-btn-container {
    display: flex;
    justify-content: flex-end;
}

.btn-pad-right {
    padding-right: 25px;
}

.pad-for-submission {
    padding-bottom: 150px;
}
</style>
